import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app/App'
import { captureRegistrationSource } from './platform/analytics/registration-source'
import './shared/styles/tokens.css'
import './shared/styles/global.css'
import './shared/ui/ui.css'

const rootElement = document.querySelector<HTMLDivElement>('#root')

if (!rootElement) {
  throw new Error('Root element #root was not found')
}

captureRegistrationSource()

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
